import React from 'react';
import './PrintableForm.css';

const ServiceAgreement: React.FC = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="printable-form-container">
      <div className="no-print actions-bar">
        <button onClick={() => window.history.back()} className="back-btn">← Back to Forms</button>
        <button onClick={handlePrint} className="print-btn">🖨️ Print / Save as PDF</button>
      </div>

      <div className="printable-form">
        <div className="form-header">
          <h1>The Pet Nanny of Weston</h1>
          <p className="tagline">Licensed • Bonded • Insured</p>
          <p className="contact">thepetnannyofweston@gmail.com</p>
        </div>

        <h2 className="form-title">Pet Care Service Agreement & Liability Waiver</h2>

        <div className="form-section">
          <h3>Service Provider & Client Information</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Client Name:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Phone Number:</label>
              <input type="tel" />
            </div>
            <div className="form-field half-width">
              <label>Email:</label>
              <input type="email" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Pet(s) Covered by this Agreement:</label>
              <textarea rows={2} placeholder="List all pet names"></textarea>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Service Start Date:</label>
              <input type="date" />
            </div>
            <div className="form-field half-width">
              <label>Service End Date:</label>
              <input type="date" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Services Provided</h3>
          <p className="section-note">The Pet Nanny of Weston agrees to provide the following pet care services:</p>
          <div style={{marginLeft: '1rem', marginTop: '1rem'}}>
            <div className="checkbox-group">
              <input type="checkbox" id="boarding" />
              <label htmlFor="boarding">Overnight Boarding (in my home)</label>
            </div>
            <div className="checkbox-group">
              <input type="checkbox" id="dropin-dog" />
              <label htmlFor="dropin-dog">Dog Drop-in Visits</label>
            </div>
            <div className="checkbox-group">
              <input type="checkbox" id="dropin-cat" />
              <label htmlFor="dropin-cat">Cat Drop-in Visits</label>
            </div>
            <div className="checkbox-group">
              <input type="checkbox" id="daycare" />
              <label htmlFor="daycare">Doggie Daycare (off-season only)</label>
            </div>
            <div className="checkbox-group">
              <input type="checkbox" id="medication" />
              <label htmlFor="medication">Medication Administration</label>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Terms of Service</h3>
          <p className="section-note"><strong>Please read each term carefully and initial to acknowledge understanding:</strong></p>
          
          <div style={{marginTop: '1rem'}}>
            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <div>
                <h4 style={{margin: '0 0 0.5rem', color: '#2c5530', fontSize: '1rem'}}>1. Payment Terms</h4>
                <p style={{margin: 0}}>
                  Payment is due at the time of drop-off unless otherwise arranged. Accepted payment methods include cash, 
                  check, or electronic payment. A deposit may be required for reservations during peak seasons and holidays.
                </p>
              </div>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <div>
                <h4 style={{margin: '0 0 0.5rem', color: '#2c5530', fontSize: '1rem'}}>2. Cancellation Policy</h4>
                <p style={{margin: 0}}>
                  Standard reservations require 48 hours notice for cancellation to receive a full refund. Holiday reservations 
                  (Thanksgiving, Christmas, New Year's, Easter, Memorial Day, July 4th, Labor Day) require 7 days notice for 
                  cancellation. Cancellations made with less notice may forfeit deposit or partial payment.
                </p>
              </div>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <div>
                <h4 style={{margin: '0 0 0.5rem', color: '#2c5530', fontSize: '1rem'}}>3. Holiday Rates</h4>
                <p style={{margin: 0}}>
                  Higher rates may apply for services during major holidays and peak seasons. Holiday rates will be 
                  communicated at the time of booking.
                </p>
              </div>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <div>
                <h4 style={{margin: '0 0 0.5rem', color: '#2c5530', fontSize: '1rem'}}>4. Vaccination Requirements</h4>
                <p style={{margin: 0}}>
                  All pets must be current on required vaccinations as specified in our vaccination policy. Dogs require: 
                  Rabies, DHPP, and Bordetella (within 6 months). Cats require: Rabies and FVRCP. Proof of vaccination 
                  must be provided before services begin. Pets not current on vaccinations may be refused service.
                </p>
              </div>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <div>
                <h4 style={{margin: '0 0 0.5rem', color: '#2c5530', fontSize: '1rem'}}>5. Flea & Tick Policy</h4>
                <p style={{margin: 0}}>
                  All pets must be free of fleas, ticks, and other parasites. Pets found to have fleas or ticks may be 
                  treated at the owner's expense, or services may be refused. Regular flea and tick prevention is required.
                </p>
              </div>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <div>
                <h4 style={{margin: '0 0 0.5rem', color: '#2c5530', fontSize: '1rem'}}>6. Health & Behavior</h4>
                <p style={{margin: 0}}>
                  Client certifies that their pet(s) are in good health and have not been exposed to any contagious illnesses 
                  in the past 30 days. Client agrees to disclose any behavioral issues, including but not limited to 
                  aggression, biting, excessive barking, or destructive behavior. The Pet Nanny of Weston reserves the right 
                  to refuse service or terminate service early for pets exhibiting dangerous or severely disruptive behavior.
                </p>
              </div>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <div>
                <h4 style={{margin: '0 0 0.5rem', color: '#2c5530', fontSize: '1rem'}}>7. Emergency Veterinary Care</h4>
                <p style={{margin: 0}}>
                  In the event of a medical emergency, The Pet Nanny of Weston will attempt to contact the client immediately. 
                  If the client cannot be reached, we are authorized to seek veterinary care on behalf of the pet as outlined 
                  in the Emergency Medical Authorization Form. Client agrees to be responsible for all veterinary expenses 
                  incurred during the pet's stay.
                </p>
              </div>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <div>
                <h4 style={{margin: '0 0 0.5rem', color: '#2c5530', fontSize: '1rem'}}>8. Medication Administration</h4>
                <p style={{margin: 0}}>
                  If medication administration is required, client must provide complete written instructions, including 
                  dosage, frequency, and method of administration. Medication must be in original containers with clear 
                  labels. While we will make every effort to administer medications as directed, we cannot guarantee that 
                  pets will accept all medications.
                </p>
              </div>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <div>
                <h4 style={{margin: '0 0 0.5rem', color: '#2c5530', fontSize: '1rem'}}>9. Food & Supplies</h4>
                <p style={{margin: 0}}>
                  Client agrees to provide adequate food, supplies, and any special items needed for their pet's stay. 
                  This includes regular food (enough for the duration of stay plus extra), medications, bedding, toys, 
                  and any comfort items. If food runs out, The Pet Nanny of Weston will purchase suitable food at the 
                  client's expense.
                </p>
              </div>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <div>
                <h4 style={{margin: '0 0 0.5rem', color: '#2c5530', fontSize: '1rem'}}>10. Drop-off & Pick-up</h4>
                <p style={{margin: 0}}>
                  Drop-off and pick-up times must be scheduled in advance. Standard hours are 8:00 AM to 8:00 PM, seven 
                  days a week. Late pick-ups may incur additional fees. Please notify us immediately if pick-up will be delayed.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Liability Waiver & Release</h3>
          <p className="section-note"><strong>Please read carefully and initial each statement:</strong></p>
          
          <div style={{marginTop: '1rem'}}>
            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <p style={{margin: 0}}>
                I understand that while The Pet Nanny of Weston will take all reasonable precautions to ensure my pet's 
                safety and wellbeing, I assume all risks associated with boarding and pet care services. I release and 
                hold harmless The Pet Nanny of Weston, its owner, and representatives from any liability for injury, 
                illness, escape, or death of my pet, except in cases of gross negligence or willful misconduct.
              </p>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <p style={{margin: 0}}>
                I understand and accept that even with the best care and supervision, pets may sustain injuries during 
                play or daily activities. I agree not to hold The Pet Nanny of Weston liable for minor injuries including 
                but not limited to scratches, scrapes, or soreness that may occur during normal play and socialization.
              </p>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <p style={{margin: 0}}>
                I certify that my pet has not been exposed to any contagious diseases within the past 30 days and is in 
                good health. I understand that despite vaccination requirements, there is always a risk of illness when 
                pets are in close contact with other animals. I will not hold The Pet Nanny of Weston responsible for 
                any illness my pet may contract.
              </p>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <p style={{margin: 0}}>
                I am responsible for any damage caused by my pet to property or injury caused to people or other animals. 
                I agree to reimburse The Pet Nanny of Weston for any damages caused by my pet during their stay.
              </p>
            </div>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'flex-start'}}>
              <input type="text" style={{width: '60px', textAlign: 'center', flexShrink: 0}} placeholder="Initial" />
              <p style={{margin: 0}}>
                I understand that personal items (toys, bedding, bowls, etc.) may become lost, soiled, or damaged during 
                my pet's stay. The Pet Nanny of Weston is not responsible for damage to or loss of personal items.
              </p>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Photo & Social Media Release</h3>
          <div className="checkbox-group" style={{marginBottom: '1rem'}}>
            <input type="checkbox" id="photo-yes" />
            <label htmlFor="photo-yes">
              <strong>YES</strong>, I grant permission for The Pet Nanny of Weston to take photos and videos of my pet 
              and use them on social media, website, and marketing materials.
            </label>
          </div>
          <div className="checkbox-group" style={{marginBottom: '1rem'}}>
            <input type="checkbox" id="photo-no" />
            <label htmlFor="photo-no">
              <strong>NO</strong>, I do not grant permission for photos/videos of my pet to be shared publicly.
            </label>
          </div>
        </div>

        <div className="form-section">
          <h3>Acknowledgments</h3>
          <p className="section-note">By checking the boxes below, I acknowledge and agree to the following:</p>
          <div style={{marginTop: '1rem'}}>
            <div className="checkbox-group">
              <input type="checkbox" id="ack1" />
              <label htmlFor="ack1">I have read and understand all terms of this service agreement</label>
            </div>
            <div className="checkbox-group">
              <input type="checkbox" id="ack2" />
              <label htmlFor="ack2">My pet(s) are current on all required vaccinations</label>
            </div>
            <div className="checkbox-group">
              <input type="checkbox" id="ack3" />
              <label htmlFor="ack3">My pet(s) are free of fleas, ticks, and contagious illnesses</label>
            </div>
            <div className="checkbox-group">
              <input type="checkbox" id="ack4" />
              <label htmlFor="ack4">I have disclosed all known behavioral issues and health concerns</label>
            </div>
            <div className="checkbox-group">
              <input type="checkbox" id="ack5" />
              <label htmlFor="ack5">I have completed and provided all required forms</label>
            </div>
            <div className="checkbox-group">
              <input type="checkbox" id="ack6" />
              <label htmlFor="ack6">I understand the cancellation policy and agree to its terms</label>
            </div>
            <div className="checkbox-group">
              <input type="checkbox" id="ack7" />
              <label htmlFor="ack7">I authorize emergency veterinary care as outlined in the Medical Authorization Form</label>
            </div>
          </div>
        </div>

        <div className="form-section signature-section">
          <h3>Signatures</h3>
          <p className="section-note">
            By signing below, I certify that I have read, understand, and agree to all terms and conditions outlined 
            in this Service Agreement and Liability Waiver. This agreement remains in effect for all current and future 
            services provided by The Pet Nanny of Weston unless revoked in writing.
          </p>
          
          <div className="form-row">
            <div className="form-field full-width">
              <label>Client Printed Name:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Client Signature:</label>
              <div className="signature-line"></div>
            </div>
            <div className="form-field half-width">
              <label>Date:</label>
              <input type="date" />
            </div>
          </div>

          <div style={{marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid #ccc'}}>
            <p style={{margin: '0 0 1rem', fontWeight: 600}}>For Office Use Only</p>
            <div className="form-row">
              <div className="form-field half-width">
                <label>Service Provider Signature:</label>
                <div className="signature-line"></div>
              </div>
              <div className="form-field half-width">
                <label>Date:</label>
                <input type="date" />
              </div>
            </div>
          </div>
        </div>

        <div className="form-footer">
          <p>Page 1 of 1</p>
          <p>The Pet Nanny of Weston • thepetnannyofweston@gmail.com</p>
        </div>
      </div>
    </div>
  );
};

export default ServiceAgreement;
